import GraphQLJSON from 'graphql-type-json';
import SAMPLE_DATA from './new-sample-data';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const getProducts = (companyId, payload, pageInput) => {
  const { brands = [], skunits = [] } = JSON.parse(payload) || {};
  return SAMPLE_DATA.filter(
    s =>
      s.companyId === companyId &&
      (brands.indexOf(s.brandId) > -1 || skunits.indexOf(s.id) > -1)
  );
};

const saveCartItem = (
  globalOutletId,
  companyId,
  { skunitId, price, cases, units, warehouseId, warehouseName }
) => {
  return {
    id: '1',
    skunitId,
    price,
    cases,
    units,
    warehouseId,
    warehouseName,
  };
};

const mocks = {
  Query: {
    skusByProperties: (_, { companyId, payload, pageInput }) =>
      getProducts(companyId, payload, pageInput),
    saveToCart: (_, { globalOutletId, companyId, cartItem }) =>
      saveCartItem(globalOutletId, companyId, cartItem),
  },
};
export { resolvers, typeResolvers, mocks };
